export default "__VITE_ASSET__BHY2Ro6$__"